import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

const lightThemeDefaultVars = {
  '--side-navigation-indicator-hover-color': m('--action-indicator-hover-color'),
  '--side-navigation-indicator-active-color': m('--action-indicator-active-color'),
  '--side-navigation-desktop-item-color': m('--action-text-default-color'),
  '--side-navigation-desktop-item-hover-color': m('--action-text-hover-color'),
  '--side-navigation-desktop-item-active-color': m('--action-text-active-color'),
  '--side-navigation-desktop-bar-bg-color': m('--bg-color'),
  '--side-navigation-mobile-bar-bg-color': m('--neutral-v200'),
  '--side-navigation-mobile-bar-fg-color': m('--action-text-active-color'),
  '--side-navigation-mobile-bg-color': m('--neutral-v150'),
  '--side-navigation-mobile-item-color': m('--action-text-default-color'),
  '--side-navigation-mobile-item-active-color': m('--action-text-active-color'),
  '--side-navigation-mobile-toggler-icon-color': m('--neutral-v700'),
  '--side-navigation-desktop-border-color': m('--neutral-v400'),
  '--side-navigation-desktop-border-width': '2px',
  '--side-navigation-right-padding': m('--spacing-xl'),
  '--side-navigation-left-padding': m('--spacing-xl'),
} as const;

export const blackThemeSideNavVars: MotifComponentProps<MotifComponent.SIDE_NAVIGATION> = {
  '--side-navigation-indicator-hover-color': m('--action-indicator-hover-color'),
  '--side-navigation-indicator-active-color': m('--action-indicator-active-color'),
  '--side-navigation-desktop-item-color': m('--action-text-default-color'),
  '--side-navigation-desktop-item-hover-color': m('--action-text-hover-color'),
  '--side-navigation-desktop-item-active-color': m('--action-text-active-color'),
  '--side-navigation-desktop-bar-bg-color': m('--bg-color'),
  '--side-navigation-mobile-bar-bg-color': m('--neutral-v650'),
  '--side-navigation-mobile-bar-fg-color': m('--neutral-v0'),
  '--side-navigation-mobile-bg-color': m('--neutral-v625'),
  '--side-navigation-mobile-item-color': m('--action-text-default-color'),
  '--side-navigation-mobile-item-active-color': m('--action-text-active-color'),
  '--side-navigation-mobile-toggler-icon-color': m('--neutral-v0'),
  '--side-navigation-desktop-border-color': m('--neutral-v600'),
  '--side-navigation-desktop-border-width': '2px',
  '--side-navigation-right-padding': m('--spacing-xl'),
  '--side-navigation-left-padding': m('--spacing-xl'),
};

export const whiteThemeSideNavVars: MotifComponentProps<MotifComponent.SIDE_NAVIGATION> = {
  ...lightThemeDefaultVars,
  '--side-navigation-mobile-bg-color': m('--neutral-v100'),
};

export const grayThemeSideNavVars: MotifComponentProps<MotifComponent.SIDE_NAVIGATION> = {
  ...lightThemeDefaultVars,
  '--side-navigation-mobile-bg-color': m('--neutral-v200'),
};

export const yellowThemeSideNavVars: MotifComponentProps<MotifComponent.SIDE_NAVIGATION> = {
  ...lightThemeDefaultVars,
  '--side-navigation-mobile-bg-color': m('--neutral-v0'),
};
